/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ruler_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An on-screen ruler in real, actual size — cm, mm and inches, calibrated to your screen.`)
};

const es_ruler_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una regla en pantalla a tamaño real y exacto — cm, mm y pulgadas, calibrada a tu pantalla.`)
};

const de_ruler_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Bildschirmlineal in echter Originalgröße — cm, mm und Zoll, kalibriert auf deinen Bildschirm.`)
};

const nl_ruler_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een liniaal op het scherm, op ware grootte — cm, mm en inches, gekalibreerd op jouw scherm.`)
};

const fr_ruler_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une règle à l'écran en taille réelle — cm, mm et pouces, calibrée pour votre écran.`)
};

const it_ruler_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un righello sullo schermo in dimensioni reali — cm, mm e pollici, calibrato sul tuo schermo.`)
};

const pt_br2_ruler_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma régua na tela em tamanho real de verdade — cm, mm e polegadas, calibrada para a sua tela.`)
};

const pt_ruler_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma régua no ecrã em tamanho real — cm, mm e polegadas, calibrada para o seu ecrã.`)
};

const ja_ruler_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画面上に実物大で表示される定規 — cm、mm、インチに対応し、画面ごとに校正できます。`)
};

const zh_ruler_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`屏幕上的真实尺寸标尺——厘米、毫米和英寸，可根据你的屏幕校准。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ruler_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ruler_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ruler_tool_description", locale)
	if (locale === "en") return en_ruler_tool_description(inputs)
	if (locale === "es") return es_ruler_tool_description(inputs)
	if (locale === "de") return de_ruler_tool_description(inputs)
	if (locale === "nl") return nl_ruler_tool_description(inputs)
	if (locale === "fr") return fr_ruler_tool_description(inputs)
	if (locale === "it") return it_ruler_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_ruler_tool_description(inputs)
	if (locale === "pt") return pt_ruler_tool_description(inputs)
	if (locale === "ja") return ja_ruler_tool_description(inputs)
	return zh_ruler_tool_description(inputs)
};